import { useState, useEffect } from 'react';

const useConflicts = (selectedCourses) => {
  const [conflicts, setConflicts] = useState([]);

  useEffect(() => {
    const newConflicts = new Set();
    const dayNameMap = {
      'Lun': 'Lunes', 'Mar': 'Martes', 'Mié': 'Miércoles', 'Jue': 'Jueves',
      'Vie': 'Viernes', 'Sáb': 'Sábado'
    };

    for (let i = 0; i < selectedCourses.length; i++) {
      for (let j = i + 1; j < selectedCourses.length; j++) {
        const courseA = selectedCourses[i];
        const courseB = selectedCourses[j];
        const dayA = dayNameMap[courseA.Dia] || courseA.Dia;
        const dayB = dayNameMap[courseB.Dia] || courseB.Dia;
        
        if (dayA === dayB) {
          const [startA_h, startA_m] = courseA['Hora Inicio'].split(':').map(Number);
          const [endA_h, endA_m] = courseA['Hora Final'].split(':').map(Number);
          const startA_min = startA_h * 60 + startA_m;
          const endA_min = endA_h * 60 + endA_m;
          
          const [startB_h, startB_m] = courseB['Hora Inicio'].split(':').map(Number);
          const [endB_h, endB_m] = courseB['Hora Final'].split(':').map(Number);
          const startB_min = startB_h * 60 + startB_m;
          const endB_min = endB_h * 60 + endB_m;
          
          if (Math.max(startA_min, startB_min) < Math.min(endA_min, endB_min)) {
            newConflicts.add(`${courseA.Curso} y ${courseB.Curso}`);
          }
        }
      }
    }
    setConflicts(Array.from(newConflicts));
  }, [selectedCourses]);

  return conflicts;
};

export default useConflicts;
